import { eventBus } from '@atc/cai-event-bus';
import { WALLET_ENSURE_PAYMENTS_INFO_REQUEST } from 'wallet-manager';
export default function ensurePaymentsInfo() {
  return () => async (dispatch, getState) => {
    const paymentsInfo = getState()?.payments;
    const isLoggedIn = getState()?.auth?.isLoggedIn || false;
    const interestRates = getState()?.interestRates || {};
    if (!paymentsInfo?.createdDate && !paymentsInfo?.isPaymentsInfoLoaded) {
      // send an event to hydrate payments info if not loaded already
      eventBus.emit(WALLET_ENSURE_PAYMENTS_INFO_REQUEST, {
        interestRates,
        isLoggedIn,
        prevPaymentsInfo: paymentsInfo
      });
    }
  };
}